import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLang } from "@/lib/i18n";
import { Reveal } from "@/components/Reveal";

const CATS = ["orders", "shipping", "returns", "sizing", "payment", "products"];

export default function FAQ() {
  const { t } = useLang();
  return (
    <div className="py-14 lg:py-20 pb-24" data-testid="faq-page">
      <div className="max-w-[820px] mx-auto px-5 lg:px-10">
        <Reveal>
          <p className="eyebrow mb-3">MIORA</p>
          <h1 className="font-serif font-light text-5xl lg:text-6xl text-ink">{t.faq.title}</h1>
          <p className="mt-4 text-ink/60 text-sm">{t.faq.sub}</p>
        </Reveal>

        <div className="mt-14 space-y-14">
          {CATS.map((cat, ci) => (
            <section key={cat} id={`faq-${cat}`} data-testid={`faq-section-${cat}`}>
              <Reveal>
                <h2 className="font-serif font-light text-2xl lg:text-3xl text-ink mb-5 flex items-center gap-4">
                  <span className="text-rose-deep text-sm font-sans">0{ci + 1}</span>
                  {t.faq.cats[cat]}
                </h2>
              </Reveal>
              <Accordion type="single" collapsible>
                {t.faq.items[cat].map((it, i) => (
                  <AccordionItem key={i} value={`${cat}-${i}`} className="border-ink/10">
                    <AccordionTrigger
                      className="text-start text-[15px] text-ink hover:text-rose-deep hover:no-underline"
                      data-testid={`faq-trigger-${cat}-${i}`}
                    >
                      {it.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-ink/65 text-sm leading-relaxed">
                      {it.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
